import React, {useMemo, useState} from 'react';

import {Button, Grid, Icon} from '@material-ui/core';
import {Card, Form, Col, InputGroup} from 'react-bootstrap';
import {format} from "date-fns";
import {useStyles} from "./styles";
import {useProductsUIContext} from "../../../contexts/ProductsUIContext";
// import {provFilterOptions} from "../ProductTable/ui.helpers";

const toDay = format(new Date(), 'yyyy-MM-dd');

export function ProductsFilterComp({ categories }) {
  const classes = useStyles();
  const context = useProductsUIContext();

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const {categoryOneDepth} = useMemo(() => ({
    categoryOneDepth: categories.map(({catNo , catNm}) => ({ catNo, catNm })),
  }), [categories]);

  const [filter, setFilter] = useState(queryParams.filter);
  const [subCategory, setSubCategory] = useState([]);

  const handleChangeFilter = (key) => (e) => {
    setFilter({...filter, [key]: e.target.value});
  };

  const handleChangeCategory = index => e => {
    const key = e.target.value;
    const category = [filter.catCd1, filter.catCd2];
    category[index] = key;
    if (index === 0 && key) {
      const {childList} = categories.find(cate => cate.catNo === key);
      setSubCategory(childList);
      category[1] = '';
    } else if (index === 0 && !key) {
      setSubCategory([]);
      category[1] = '';
    }
    const [catCd1, catCd2] = category;
    setFilter({...filter, catCd1, catCd2});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const _filter = {
      ...filter,
      startDt: filter.startDt ? format(new Date(filter.startDt), 'yyyyMMdd') : '',
      endDt: filter.endDt ? format(new Date(filter.endDt), 'yyyyMMdd') : '',
    }
    setQueryParams({...queryParams, filter: _filter});
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Card>
        <Card.Body>
          <Card.Title as="h5" className="mb-5">
            <Icon color="secondary" className="mr-2 align-middle">search</Icon>
            검색
          </Card.Title>
          <hr className="mb-10"/>
          <Grid container>
            <Grid item xs={12} lg={6}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="category1">
                  <Form.Label>상품 카테고리</Form.Label>
                  <Form.Control
                    as="select"
                    value={filter.catCd1}
                    onChange={handleChangeCategory(0)}
                  >
                    <option value="">전체</option>
                    {categoryOneDepth.map(cate => (
                      <option key={cate.catNo} value={cate.catNo}>{cate.catNm}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} controlId="category2" className={classes.formGroup}>
                  <Form.Control
                    as="select"
                    value={filter.catCd2}
                    onChange={handleChangeCategory(1)}
                  >
                    <option value="">전체</option>
                    {subCategory.map(cate => (
                      <option key={cate.catNo} value={cate.catNo}>{cate.catNm}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="goodsNo">
                  <Form.Label>상품 코드</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="상품 코드를 입력하세요."
                    value={filter.goodsNo}
                    onChange={handleChangeFilter('goodsNo')}
                  />
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="goodsNm">
                  <Form.Label>상품명</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="상품명를 입력하세요."
                    value={filter.goodsNm}
                    onChange={handleChangeFilter('goodsNm')}
                  />
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col}>
                  <Form.Label>상품 등록일자</Form.Label>
                  <InputGroup>
                    <Form.Control
                      id="startDt"
                      type="date"
                      max={filter.endDt}
                      value={filter.startDt}
                      placeholder="yyyy. mm. dd"
                      aria-describedby="basic-addon1"
                      onChange={handleChangeFilter('startDt')}
                    />
                    <InputGroup.Prepend>
                      <InputGroup.Text>~</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      id="endDt"
                      type="date"
                      min={filter.startDt}
                      max={toDay}
                      value={filter.endDt}
                      placeholder="yyyy. mm. dd"
                      aria-describedby="basic-addon2"
                      onChange={handleChangeFilter('endDt')}
                    />
                  </InputGroup>
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={12} className="text-right pl-3 pr-3">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                className="w-130px"
              >
                검색
              </Button>
            </Grid>
          </Grid>
        </Card.Body>
      </Card>
    </Form>
  );
}

export const ProductsFilter = React.memo(ProductsFilterComp);
